import { atomWithReset } from 'jotai/utils';

import { ChangeDeliveryMethodModal } from './types';

export const changeDeliveryMethodState = atomWithReset<ChangeDeliveryMethodModal>({
  isOpen: false,
  appointmentId: null,
});
